import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import RankBlock from "../../components/RankBlock";
import { getCumulativeCount } from "../../apis/PeopleCount.Api";
import { useSnackbar } from "notistack";
import moment from "moment";

const DailyFootfallRank = ({ selectedBuilding }) => {
    const userData = useSelector((state) => state.userData.data);
    const rooms = useSelector((state) => state.room.data);

    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);
    const [dateType, setDateType] = useState("TODAY"); // TODAY, YESTERDAY, WEEK, MONTH
    const [rankDataArray, setRankDataArray] = useState([
        {
            number: 0,
            name: " --- ",
        },
        {
            number: 0,
            name: " --- ",
        },
        {
            number: 0,
            name: " --- ",
        },
    ]);

    async function getRankData() {
        setIsLoading(true);
        try {
            const startObj =
                dateType === "YESTERDAY"
                    ? moment().subtract(1, "days")
                    : dateType === "WEEK"
                    ? moment().subtract(7, "days")
                    : dateType === "MONTH"
                    ? moment().subtract(1, "months")
                    : moment();

            const res = await getCumulativeCount({
                room_id: JSON.stringify(
                    Object.values(rooms)
                        .filter((room) => room.buildingId === selectedBuilding)
                        .map((room) => room.roomId)
                ),
                start_time: moment(startObj.startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")).format("YYMMDDHHmmssSSS"),
                end_time: moment(moment().endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS")).format("YYMMDDHHmmssSSS"),
            });
            if (!res.data.indicator) {
                enqueueSnackbar(res.data.message, { variant: "error" });
                setIsLoading(false);
                return;
            }
            const rankData = res.data.message;
            rankData.sort((a, b) => b.cumulative_count - a.cumulative_count);

            setRankDataArray(
                rankData.slice(0, 3).map((data) => ({
                    number: data.cumulative_count,
                    name: rooms[data.room_id].roomName,
                }))
            );
        } catch (error) {
            console.log(error);
            enqueueSnackbar("Failed to get rank data", { variant: "error" });
        }
        setIsLoading(false);
    }

    useEffect(() => {
        getRankData();
    }, [selectedBuilding, dateType]);
    return (
        <RankBlock
            className="daily-footfall-rank"
            rankDataArray={rankDataArray}
            dateType={dateType}
            setDateType={setDateType}
            isLoading={isLoading}
        />
    );
};

export default DailyFootfallRank;
